module.exports = __webpack_public_path__ + "static/media/HCRA Compliance Order - 2661793 Ontario Inc-Bluestone Homes - May 21- 2025.8775cf83.pdf";